module.exports = __webpack_public_path__ + "static/media/diktat-23.705fe13b.mp3";